import { useApiGet, type UseApiOptions, useApiPut } from "@ametie/vue-muza-use";

import type { Partnership, Vendor } from "../types";

export interface SwitchPartnershipPayload {
  userID: string
  partnership: Partnership
}

export interface SwitchPartnershipResponse {
  userID: string
  partnership: Partnership
}

export default () => {
  const switchPartnership = (
    options?: UseApiOptions<SwitchPartnershipResponse, SwitchPartnershipPayload>,
  ) => useApiPut("/auth/user-partnership", options);

  // cache: true → auto-key "GET:/vendors" + global cacheDefaults (swr, 1h fresh / 5h stale)
  const fetchVendors = (options?: UseApiOptions<Vendor[]>) =>
    useApiGet("/vendors", { cache: true, ...options });

  return { switchPartnership, fetchVendors };
};
